import React from 'react';

import { BooleanParam, StringParam } from 'use-query-params';
import { useQueryParamsWithHistory } from '../../../../../hooks/useQueryParamsWithHistory';

import ButtonIcon from '../../../../../components/ButtonIcon';
import MenuList from '../../../../../components/ArrayMenuList/ArrayMenuList';
import { useDropdownMenu } from '../../../../../components/DropdownMenu';
import MenuItem from '../../../../../components/MenuItem';
import Panel from '../../../../../components/Panel';
import Switch from '../../../../../components/Switch';
import Tooltip from '../../../../../components/Tooltip';
import Typography from '../../../../../components/Typography';
import SvgCog from '../../../../../components/icons/Cog';
import SvgFullScreen from '../../../../../components/icons/FullScreen';
import SvgFullScreenClose from '../../../../../components/icons/FullScreenClose';
import SvgInfo from '../../../../../components/icons/Info';

import { TagStyled, TotalHeaderCell, TotalTooltipContentContainer } from '../../../styles/OptimizationProposal';

import { nexyColors } from '../../../../../theme';
import { SwitchContainerStyled } from '../../Funnel/styles';

export const TotalHeaderCellElement = () => {
  const [queryParams] = useQueryParamsWithHistory({
    showSkippedContents: BooleanParam,
  });
  return (
    <>
      <TotalHeaderCell>
        Total
        <Tooltip
          size="large"
          style={{
            maxWidth: 414,
          }}
          popperProps={{
            style: {
              zIndex: 3300,
            },
          }}
          placement="bottom-start"
          variant="dark"
          content={
            <TotalTooltipContentContainer>
              The "Total" row only contains the combined numbers for:
              <br />
              <Typography
                style={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'center' }}
                withEllipsis={false}
              >
                Contents marked as{' '}
                <TagStyled color={nexyColors.darkGrey} bgColor="#88E7B7">
                  Standard
                </TagStyled>{' '}
                ,{' '}
                <TagStyled color={nexyColors.darkGrey} bgColor="#FAB570">
                  Limited
                </TagStyled>
                ,{' '}
                <TagStyled color={nexyColors.darkGrey} bgColor="#94DCF4">
                  Insight
                </TagStyled>
                {queryParams.showSkippedContents ? (
                  <>
                    and{' '}
                    <TagStyled color={nexyColors.darkGrey} bgColor={nexyColors.frenchGray}>
                      Skip
                    </TagStyled>
                  </>
                ) : (
                  '.'
                )}
              </Typography>
            </TotalTooltipContentContainer>
          }
        >
          <div>
            <SvgInfo style={{ color: nexyColors.coolGray, width: 18, height: 18 }} />
          </div>
        </Tooltip>
      </TotalHeaderCell>
    </>
  );
};

export const ActionsCornerElementHeader = () => {
  const { open: tooltipOpen, closeMenu: closeTooltip, openMenu: openTooltip } = useDropdownMenu();
  const { anchorEl, open, toggleMenu, closeMenu } = useDropdownMenu();
  const [queryParams, setQueryParams] = useQueryParamsWithHistory({
    expandedOptimizationView: BooleanParam,
    showSkippedContents: BooleanParam,
    tableViewSwitch: StringParam,
  });
  return (
    <>
      <Tooltip
        popperProps={{
          style: {
            zIndex: 3301,
          },
        }}
        open={tooltipOpen}
        size="small"
        placement="right"
        variant="dark"
        content={queryParams.expandedOptimizationView ? 'Minimize view' : 'Expand view'}
      >
        <ButtonIcon
          onMouseLeave={closeTooltip}
          onMouseEnter={openTooltip}
          onClick={() => {
            closeTooltip();
            setQueryParams({
              expandedOptimizationView: !queryParams.expandedOptimizationView,
            });
          }}
          style={{ marginRight: 'auto', padding: 9 }}
        >
          {queryParams.expandedOptimizationView ? (
            <SvgFullScreenClose style={{ color: nexyColors.coolGray, width: 17, height: 17 }} />
          ) : (
            <SvgFullScreen style={{ color: nexyColors.coolGray, width: 17, height: 17 }} />
          )}
        </ButtonIcon>
      </Tooltip>
      {queryParams.tableViewSwitch === 'all-content' ? (
        <>
          <Tooltip
            popperProps={{
              style: {
                zIndex: 3301,
              },
            }}
            size="small"
            placement="right"
            variant="dark"
            content="Table view settings"
          >
            <div>
              <ButtonIcon ref={anchorEl} onClick={toggleMenu} style={{ marginRight: 'auto', padding: 9 }}>
                <SvgCog style={{ color: nexyColors.coolGray, width: 17, height: 17 }} />
              </ButtonIcon>
            </div>
          </Tooltip>
          <Panel
            open={open}
            onClose={closeMenu}
            color="dark"
            anchorEl={anchorEl.current}
            placement="bottom-start"
            popperProps={{
              style: {
                zIndex: 3301,
              },
            }}
          >
            <MenuList color="dark">
              <MenuItem
                onClick={(e) => {
                  e.preventDefault();
                  setQueryParams({
                    showSkippedContents: !queryParams.showSkippedContents,
                  });
                }}
                style={{
                  minWidth: 125,
                  maxHeight: 500,
                }}
              >
                <SwitchContainerStyled>
                  <Typography>Show skipped and disabled contents</Typography>
                  <Switch
                    isOn={queryParams.showSkippedContents}
                    onToggle={() => {
                      setQueryParams({
                        showSkippedContents: !queryParams.showSkippedContents,
                      });
                    }}
                  />
                </SwitchContainerStyled>
              </MenuItem>
            </MenuList>
          </Panel>
        </>
      ) : null}
    </>
  );
};
